// AddNewProduct.jsx
import React, { useState, useRef,useEffect } from "react";
import {Box,Typography,TextField,Button,Tabs,Tab,Breadcrumbs,Paper,Chip,IconButton,Stack,Tooltip,useMediaQuery,Select, MenuItem,FormControlLabel,Checkbox, Link} from "@mui/material";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { v4 as uuidv4 } from "uuid";
// import DeleteIcon from "@mui/icons-material/Delete";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import api from "../../api/axios";
import { DndContext,closestCenter,PointerSensor, useSensor,useSensors} from "@dnd-kit/core";
import {
    AutoFixHigh 
} from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import RichTextEditor from "./RichTextEditor";
import { CSS } from "@dnd-kit/utilities";
import { productChecklist } from "../../utils/validation";

import { useParams } from "react-router-dom";

// Single draggable item
function SortableMediaItem({ item, removeMedia }) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    position: "relative",
    borderRadius: 8,
    border: "1px solid #ddd",
    overflow: "hidden",
    background: "#fff",
    padding: 4,
  };

  return (
    <Box ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {item.type === "image" ? (
        <img
          src={item.preview}
          alt=""
          style={{
            width: "100%",
            height: 120,
            objectFit: "cover",
            borderRadius: 4,
          }}
        />
      ) : (
        <video
          src={item.preview}
          controls
          style={{
            width: "100%",
            height: 120,
            objectFit: "cover",
            borderRadius: 4,
          }}
        />
      )}

      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();   // 🔥 THIS IS THE KEY
          removeMedia(item.id, item.isExisting);
        }}
        sx={{
          position: "absolute",
          top: 5,
          right: 5,
          bgcolor: "rgba(0,0,0,0.6)",
          color: "#fff",
        }}
      >
        ✕
      </IconButton>
    </Box>
  );
}

const ProductChecklist = ({ product }) => {
  const checklist = productChecklist(product);

  return (
    <Box sx={{ mt: 2 }}>
      <Typography fontWeight={600}>Listing status</Typography>

      {checklist.map((c) => (
        <Typography key={c.label} color={c.ok ? "green" : "red"}>
          {c.ok ? "✔" : "✖"} {c.label}
        </Typography>
      ))}
    </Box>
  );
};

// The grid itself
function MediaGrid({ media, setMedia, removeMedia }) {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over?.id) {
      const oldIndex = media.findIndex((m) => m.id === active.id);
      const newIndex = media.findIndex((m) => m.id === over.id);
      setMedia(arrayMove(media, oldIndex, newIndex));
    }
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={media.map((i) => i.id)}
        strategy={verticalListSortingStrategy}
      >
<Box
  sx={{
    mt: 2,
    display: "grid",
    gap: 1.5,
    gridTemplateColumns: {
      xs: "repeat(2, 1fr)",
      sm: "repeat(auto-fill, minmax(140px, 1fr))",
    },
  }}
>
          {media.map((item) => (
            <SortableMediaItem
              key={item.id}
              item={item}
              removeMedia={removeMedia}
            />
          ))}
        </Box>
      </SortableContext>
    </DndContext>
  );
}

// Small helper to compute cartesian product of variant option arrays
const cartesian = (arrays) => {
  if (!arrays.length) return [];
  return arrays.reduce((acc, curr) => {
    const res = [];
    acc.forEach((a) => {
      curr.forEach((c) => res.push([...a, c]));
    });
    return res;
  }, [[]]);
};

export default function AddNewProduct() {
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);

  // Basic product fields
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [subcategory, setSubcategory] = useState("");
  const [price, setPrice] = useState("");
  const [stock, setStock] = useState("");
  const [description, setDescription] = useState("");
  const [isFeatured, setIsFeatured] = useState(false);

  // Media
  const [media, setMedia] = useState([]);
  const [checkOpen, setCheckOpen] = useState(true);
  const [aiError, setAiError] = useState(null);

  const [saving, setSaving] = useState(false);
const [existingMedia, setExistingMedia] = useState([]);
  const inputFileRef = useRef(null);

  // non-selectable specs
const [attributes, setAttributes] = useState([
  // { name: "Material", value: "Engineering Wood" }
]);
  // Variants: array of { name: "Size", options: ["S","M"] }
  const [variants, setVariants] = useState([]);
  const [combinations, setCombinations] = useState([]); // generated combinations
  const [mediaChecklist, setMediaChecklist] = useState({
  hasImage: false,
  hasVideo: false,
});

  const REQUIRED_FIELDS = ["title", "price", "description"];
const { id } = useParams();
const isEditMode = Boolean(id);

const [policies, setPolicies] = useState({
  returnPolicy: "",
  shippingPolicy: "",
  warranty: "",
  processingTime: "",
});

  useEffect(() => {
  if (!isEditMode) return;

  const loadProduct = async () => {
    try {
      const res = await api.get(`/products/${id}`);
      const p = res.data.product;

      setProductId(p._id);
      setTitle(p.title || "");
      setDescription(p.description || "");
      setCategory(p.category || "");
      setSubcategory(p.subcategory || "");
      setPrice(p.price || "");
      setStock(p.stock || "");
      setPolicies(p.policies || "");
      setIsFeatured(p.isFeatured || false);
      const normalizeVariantsForUI = (variantsFromDB = []) => {
  const map = {};

  variantsFromDB.forEach((v) => {
    const entries = Object.entries(v.attributes || {});
    entries.forEach(([name, value]) => {
      if (!map[name]) map[name] = new Set();
      map[name].add(value);
    });
  });

  return Object.entries(map).map(([name, set]) => ({
    name,
    options: Array.from(set),
  }));
};

setVariants(normalizeVariantsForUI(p.variants));
setAttributes(p.attributes || []);
setCombinations(p.combinations || []);

      // 🔥 existing media (Amazon-style)
      setExistingMedia(p.media || []);
    } catch (err) {
      console.error(err);
      alert("Failed to load product for editing");
    }
  };

  loadProduct();
}, [id]);


useEffect(() => {
  const result = validateMediaRequirements(media, existingMedia);
  setMediaChecklist(result);
}, [media, existingMedia]);

useEffect(() => {
  const fetchPolicies = async () => {
    try {
      const { data } = await api.get("/vendor/policies");

      setPolicies({
        returnPolicy: data.policies?.returnPolicy || "",
        shippingPolicy: data.policies?.shippingPolicy || "",
        processingTime: data.policies?.processingTime || "1_day",
        useVendorDefaults: true,
      });
    } catch (err) {
      console.error("Failed to fetch policies", err);
    }
  };

  fetchPolicies();
}, []);

const validateMediaRequirements = (mediaList = [], existingMedia = []) => {
  const allMedia = [...existingMedia, ...mediaList];

  const imageCount = allMedia.filter(
    (m) =>
      (m.type === "image") ||
      (m.file && m.file.type?.startsWith("image/"))
  ).length;

  const videoCount = allMedia.filter(
    (m) =>
      (m.type === "video") ||
      (m.file && m.file.type?.startsWith("video/"))
  ).length;

  return {
    hasImage: imageCount >= 1,
    hasVideo: videoCount >= 1,
  };
};

const handleSave = async () => {
  try {
    const { data } = await api.patch("/vendor/policies", policies);

    alert("Policies saved successfully");
  } catch (err) {
    console.error(err);
    alert(err?.response?.data?.message || "Failed to save policies");
  }
};
  // -------------------------
  // Excel -> form mapping
  // -------------------------
  const handleImportExcelToForm = async (file) => {
    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet);

      const first = json[0];
      if (first) {
        setTitle(first.name || first.Name || "");
        setCategory(first.category || first.Category || "");
        setPrice(first.price ? String(first.price) : "");
        setStock(first.stock ? String(first.stock) : "");
        setDescription(first.description || first.Description || "");
        if (first.variant_size) {
          const sizeOpts = String(first.variant_size).split(",").map((s) => s.trim()).filter(Boolean);
          setVariants((v) => {
            const copy = [...v];
            copy.push({ name: "Size", options: sizeOpts });
            return copy;
          });
        }
        alert("Excel mapped to form (first row). Edit fields if needed and submit.");
        setTab(1);
      }
    } catch (err) {
      console.error(err);
      alert("Failed to import Excel file.");
    }
  };

const [productId, setProductId] = useState(null);
const buildFormData = (status = "draft") => {
  const fd = new FormData();
  fd.append("title", title);
  fd.append("description", description);
  fd.append("price", price);
  fd.append("stock", stock);
  fd.append("category", category);
  fd.append("subcategory", subcategory);
  fd.append("status", status); // 🔥 REQUIRED
  fd.append("attributes", JSON.stringify(attributes));
  fd.append("variants", JSON.stringify(variants));
  fd.append("combinations", JSON.stringify(combinations));
  fd.append("policies", JSON.stringify(policies));
  fd.append("isFeatured", isFeatured.toString());
  // upload ONLY newly added files
  media.forEach((m) => {
    if (m.file) {
      fd.append("media", m.file);
    }
  });

  // tell backend which media already exists
  fd.append(
    "existingMediaKeys",
    JSON.stringify(
      existingMedia
        .map((m) => m.key)
        .filter(Boolean)
    )
  );
  return fd;
};

const saveDraft = async () => {
  if (saving) return; // 🔒 prevent double clicks
  setSaving(true);
  setAiError(null);
  try {
    const fd = buildFormData();
    let res;
    if (!productId) {
      // 🔥 FIRST TIME → CREATE
      res = await api.post("/products", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setProductId(res.data.productId);
       // clear previous AI errors
    } else {
      // 🔥 SUBSEQUENT SAVES → UPDATE
              console.log(
          "EXISTING MEDIA BEFORE PATCH",
          existingMedia,
          existingMedia.map((m) => m._id || m.id)
        );
      res = await api.patch(`/products/${productId}`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setProductId(res.data.productId);
    }

    // sync media from backend response
if (res.data.media) {
  setExistingMedia(res.data.media); // authoritative list
  setMedia([]); // 🔥 clear newly uploaded files
  setAiError(null); // clear previous AI errors
}
alert("Draft saved");
  } catch (err) {
    // console.error(err);
    // alert("Save draft failed");
    const data = err.response?.data;
      setAiError({
        message: data?.message || "Draft failed",
        reasons: data?.reasons || [],
      });
  } finally {
    setSaving(false);
  }
};

const canSubmitForReview = (product) => {
  return productChecklist(product)
    .filter((c) => c.requiredForSubmit)
    .every((c) => c.ok);
};

const productForChecklist = {
  title,
  description,
  price,
  stock,
  category,
  subcategory,
  attributes,
  variants,

  // 🔥 IMPORTANT: include BOTH
  media: [
    ...existingMedia,
    ...media,
  ],
};


const publish = async () => {
  if (!productId) {
    alert("Save draft first");
    return;
  }

  // 🔥 Checklist gate (UI-side)
const checklist = productChecklist(productForChecklist);
  const blockingItems = checklist.filter(
    (c) => c.requiredForSubmit && !c.ok
  );

  if (blockingItems.length > 0) {
    alert(
      "Please complete the following before submitting for review:\n\n" +
        blockingItems.map((c) => `• ${c.label}`).join("\n")
    );
    return;
  }

  try {
    const res = await api.patch(`/products/${productId}/publish`);
  setAiError(null);
    alert(res.data.message || "Product submitted for review");
    navigate("/vendor/products");
  } catch (err) {
    const data = err.response?.data;

    setAiError({
      message: data?.message || "Publish failed",
      reasons: data?.reasons || [],
    });
  }
};


    // Process both images + videos
const processFiles = (files) => {
  const valid = Array.from(files).filter((f) =>
    f.type.startsWith("image/") || f.type.startsWith("video/")
  );

  const mapped = valid.map((file) => ({
    id: uuidv4(),
    file,
    preview: URL.createObjectURL(file),
    type: file.type.startsWith("video/") ? "video" : "image",
  }));

  setMedia((prev) => [...prev, ...mapped]);
};

const handleFileInput = (e) => {
  if (e.target.files?.length) {
    processFiles(e.target.files);
  }
};
const handleDragOver = (e) => {
  e.preventDefault();
  e.dataTransfer.dropEffect = "copy";
};

const handleDrop = (e) => {
  e.preventDefault();
  if (e.dataTransfer.files?.length) {
    processFiles(e.dataTransfer.files);
  }
};


const removeMedia = async (id, isExisting) => {
  // 1️⃣ NEW (unsaved) media → UI only
  if (!isExisting) {
    setMedia((prev) => prev.filter((m) => m.id !== id));
    return;
  }

  // 2️⃣ EXISTING media → delete from backend + S3
  try {
    await api.delete(`/products/${productId}/media/${id}`);

    setExistingMedia((prev) =>
      prev.filter((m) => m._id !== id)
    );
  } catch (err) {
    console.error(err);
    alert("Failed to delete media. Please try again.");
  }
};

  // -------------------------
  // Variant management
  // -------------------------
  const addVariant = () => setVariants((v) => [...v, { name: "", options: [] }]);
  const updateVariantName = (idx, name) => {
    setVariants((v) => v.map((x, i) => (i === idx ? { ...x, name } : x)));
  };
  const updateVariantOptions = (idx, val) => {
    const options = val.split(",").map((o) => o.trim()).filter(Boolean);
    setVariants((v) => v.map((x, i) => (i === idx ? { ...x, options } : x)));
  };
  const removeVariant = (idx) => setVariants((v) => v.filter((_, i) => i !== idx));

  // Generate combinations (cartesian product)
  const generateCombinations = () => {
    if (!variants.length) {
      setCombinations([]);
      return;
    }
    const arrays = variants.map((v) => v.options.map((opt) => ({ [v.name]: opt })));
    const raw = cartesian(arrays);
    const merged = raw.map((arr) => Object.assign({}, ...arr));
    const withMeta = merged.map((m, i) => ({ id: `comb-${i}-${Date.now()}`, ...m, price: price || "", stock: stock || 0 }));
    setCombinations(withMeta);
    setTab(3); // go to pricing tab
  };

  // Bulk upload: whole excel import into localStorage demo
  const handleBulkUploadProducts = async (file) => {
    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet);
      const mapped = json.map((r, i) => ({
        id: `excel-${Date.now()}-${i}`,
        title: r.name || r.Name || `Untitled ${i + 1}`,
        category: r.category || r.Category || "Uncategorized",
        price: String(r.price ?? r.Price ?? "0"),
        stock: Number(r.stock ?? r.Stock ?? 0),
        description: r.description || r.Description || "",
      }));

      const existing = JSON.parse(localStorage.getItem("vendorProducts") || "[]");
      localStorage.setItem("vendorProducts", JSON.stringify([...mapped, ...existing]));
      alert(`Imported ${mapped.length} products. Stored in localStorage for demo.`);
      navigate("/vendor/products");
    } catch (err) {
      console.error(err);
      alert("Failed to read Excel file.");
    }
  };

const isMobile = useMediaQuery("(max-width:900px)");
const combinedMedia = [
  ...existingMedia.map((m) => ({
    ...m,                 // full backend object
    id: m._id,            // 🔑 UNIQUE & STABLE
    preview: m.url,
    isExisting: true,
  })),
  ...media.map((m) => ({
    ...m,
    id: m.id,             // uuid for new uploads
    preview: m.preview,
    isExisting: false,
  })),
];



 return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f0f2f5" }}>
      {/* ================= HEADER (matches Dashboard / VendorOrders) ================= */}
      <Box sx={{ background: 'linear-gradient(135deg, #0f172a 0%, #0062ff 100%)', px: { xs: 2, sm: 4 }, py: 2.5, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 0.5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Button onClick={() => navigate("/vendor/dashboard")} sx={{ color: "rgba(255,255,255,0.7)", textTransform: "none", fontSize: "0.82rem", fontWeight: 500, mb: 0.5, p: 0, "&:hover": { color: "#fff", bgcolor: "transparent" }, display: "flex", alignItems: "center", gap: 0.5 }}>
              <ArrowBackIcon sx={{ fontSize: 16 }} />
              Back to Dashboard
            </Button>
            <Typography variant="h5" fontWeight={700} sx={{ color: '#fff' }}>
              {isEditMode ? "✏️ Edit Product" : "➕ Add New Product"}
            </Typography>
          </Box>
        </Box>
        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.5)' }}>Fill in the product details and submit for review.</Typography>
      </Box>

      <Box sx={{ px: { xs: 2, sm: 4 }, pb: 4, maxWidth: 1200, mx: "auto" }}>
        {/* ================= AI ERROR ================= */}
        {aiError && (
          <Paper
            sx={{
              mb: 2,
              p: 2,
              borderRadius: 2,
              border: "1px solid #f44336",
              bgcolor: "#fff5f5",
            }}
          >
            <Typography fontWeight={700} color="error">
              {aiError.message}
            </Typography>

            {aiError.reasons?.length > 0 && (
              <Box sx={{ mt: 1 }}>
                {aiError.reasons.map((r, i) => (
                  <Typography
                    key={i}
                    variant="body2"
                    color="error"
                    sx={{ ml: 1 }}
                  >
                    • {r}
                  </Typography>
                ))}
              </Box>
            )}
          </Paper>
        )}
          <Paper sx={{ mb: 2 }}>
            <Tabs
              value={tab}
              onChange={(e, v) => setTab(v)}
              variant={isMobile ? "scrollable" : "standard"}
              scrollButtons={isMobile ? "auto" : false}
              allowScrollButtonsMobile
              sx={{
                "& .MuiTab-root": {
                  minWidth: isMobile ? 120 : "auto",
                  fontWeight: 600,
                  textTransform: "none",
                },
              }}
            >

          {/* <Tab label="Category" /> */}
          <Tab label="Details" />
          <Tab label="Attributes" />   {/* NEW */}
          <Tab label="Variants" />
          <Tab label="Pricing & Inventory" />
          <Tab label="Media" />
          <Tab label="Product Policies" />
          {/* <Tab label="Store Policies" /> */}
          {/* <Tab label="Bulk Import" /> */}
        </Tabs>
      </Paper>

      {/* TAB 1 — DETAILS */}
      {tab === 0 && (
        <Box sx={{ maxWidth: 1000 }}>
<Box sx={{ mb: 2 }}>
  <Typography fontWeight={600} sx={{ mb: 0.5 }}>Product title</Typography>
  
  <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
    <TextField
      fullWidth
      placeholder="e.g. Heavy Duty Hydraulic Cutting Machine for Agriculture"
      value={title}
      onChange={(e) => setTitle(e.target.value)}
    />

    <Tooltip title="Optimize title using AI">
      <IconButton
        sx={{
          mt: 0.5,
          bgcolor: "#f3e8ff",
          color: "#6f42c1",
          "&:hover": { bgcolor: "#e9d5ff" },
        }}
        onClick={async () => {
          const res = await api.post("/ai/optimize-title", {
            title,
            category,
          });
          setTitle(res.data.title);
        }}
      >
        <AutoFixHigh />
      </IconButton>
    </Tooltip>
  </Box>

  <Typography variant="caption" color="text.secondary">
    Keep titles clear, brand-free, and under 200 characters.
  </Typography>
</Box>
          <Box sx={{ mt: 3 }}>
  <Typography fontWeight={600} sx={{ mb: 1 }}>
    Product description
  </Typography>

  <Box sx={{ mx: { xs: -2, sm: 0 } }}>
  <RichTextEditor value={description} onChange={setDescription} />
  </Box>

  <Typography variant="caption" color="text.secondary">
    Use bullet points and clear feature descriptions for better conversions.
  </Typography>
</Box>
          <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
            <Button variant="contained" sx={{ background: "#ff9900" }} onClick={() => setTab(1)}>Next: Attributes</Button>
            {/* <Button variant="outlined" onClick={() => { setTab(1); }}>Back</Button> */}
          </Box>
        </Box>
      )}

{tab === 1 && (
  <Box sx={{ maxWidth: 1000 }}>
    <Typography fontWeight={600} sx={{ mb: 2 }}>
      Product specifications (non-selectable)
    </Typography>

    <Stack spacing={2}>
      {attributes.map((a, idx) => (
        <Box key={idx} sx={{ display: "flex", gap: 2 }}>
          <TextField
            placeholder="Attribute name (e.g. Material)"
            value={a.name}
            onChange={(e) =>
              setAttributes((p) =>
                p.map((x, i) =>
                  i === idx ? { ...x, name: e.target.value } : x
                )
              )
            }
          />
          <TextField
            placeholder="Value (e.g. Engineering Wood)"
            value={a.value}
            sx={{ flex: 1 }}
            onChange={(e) =>
              setAttributes((p) =>
                p.map((x, i) =>
                  i === idx ? { ...x, value: e.target.value } : x
                )
              )
            }
          />
          <Button color="error" onClick={() =>
            setAttributes((p) => p.filter((_, i) => i !== idx))
          }>
            Remove
          </Button>
        </Box>
      ))}

      <Button startIcon={<AddIcon />} onClick={() =>
        setAttributes((p) => [...p, { name: "", value: "" }])
      }>
        Add attribute
      </Button>
    </Stack>
              <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
            <Button variant="contained" sx={{ background: "#ff9900" }} onClick={() => setTab(2)}>Next: Variants</Button>
            {/* <Button variant="outlined" onClick={() => { setTab(1); }}>Back</Button> */}
          </Box>
  </Box>
)}

      {/* TAB 2 — VARIANTS */}
      {tab === 2 && (
        <Box sx={{ maxWidth: 1000 }}>
          <Typography sx={{ mb: 2 }}>Variants (e.g. Size, Color). Enter options comma-separated.</Typography>

          <Stack spacing={2}>
            {variants.map((v, idx) => (
              <Box key={idx} sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                <TextField placeholder="Variant name (e.g. Size)" value={v.name} onChange={(e) => updateVariantName(idx, e.target.value)} />
                {/* <TextField placeholder="Options (comma separated)" value={v.options.join(", ")} onChange={(e) => updateVariantOptions(idx, e.target.value)} sx={{ flex: 1 }} /> */}
                  <TextField
                    placeholder="Options (comma separated)"
                    value={(v.options || []).join(", ")}
                    onChange={(e) => updateVariantOptions(idx, e.target.value)}
                    sx={{ flex: 1 }}
                  />
                <Button color="error" onClick={() => removeVariant(idx)}>Remove</Button>
              </Box>
            ))}

            <Box>
              <Button onClick={addVariant} startIcon={<AddIcon />}>Add Variant</Button>
            </Box>

            <Box>
              <Button variant="contained" onClick={generateCombinations} sx={{ background: "#ff9900" }}>Generate Combinations</Button>
              <Button sx={{ ml: 2 }} onClick={() => setTab(3)}>Skip to Pricing</Button>
            </Box>

            {/* combinations preview */}
            {combinations.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle1">Generated combinations:</Typography>
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1 }}>
                  {combinations.map((c) => (
                    <Chip key={c.id} label={Object.entries(c).filter(([k]) => k !== "id").map(([k, v]) => `${k}:${v}`).join(" | ")} />
                  ))}
                </Box>
              </Box>
            )}
          </Stack>
        </Box>
      )}

      {/* TAB 3 — PRICING */}
      {tab === 3 && (
        <Box sx={{ maxWidth: 700 }}>
          <TextField label="Price" value={price} onChange={(e) => setPrice(e.target.value)} sx={{ mb: 2 }} fullWidth />
          <TextField label="Stock Quantity" value={stock} onChange={(e) => setStock(e.target.value)} sx={{ mb: 2 }} fullWidth />
          
          <Box sx={{ mb: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isFeatured}
                  onChange={(e) => setIsFeatured(e.target.checked)}
                  color="primary"
                />
              }
              label="Mark as Featured Product"
            />
            <Typography variant="caption" color="text.secondary">
              Featured products will be displayed prominently on your store page
            </Typography>
          </Box>

          <Box sx={{ display: "flex", gap: 2 }}>
            <Button variant="contained" sx={{ background: "#ff9900" }} onClick={() => setTab(4)}>Next: Media</Button>
            <Button variant="outlined" onClick={() => setTab(2)}>Back</Button>
          </Box>
        </Box>
      )}

      {/* TAB 4 — MEDIA UPLOAD */}
      {tab === 4 && (
  <Box sx={{ maxWidth: 1000 }}>
  <Typography>
    Drag & drop product images or videos here (or click Upload).
    You can reorder and remove items.
  </Typography>

<Box
  onDragOver={handleDragOver}
  onDrop={handleDrop}
  onClick={() => inputFileRef.current?.click()}
  sx={{
    mt: 2,
    border: "2px dashed #d5d9d9",
    borderRadius: 2,
    p: 4,
    textAlign: "center",
    background: "#f7fafa",
    cursor: "pointer",
    transition: "0.2s",
    "&:hover": {
      background: "#eef3f3",
      borderColor: "#999",
    },
  }}
>
<Typography variant="caption" color="text.secondary">
  First image will be used as the main product image
</Typography>

    <input
      ref={inputFileRef}
      type="file"
      accept="image/*,video/*"   // ✅ allow videos
      multiple
      hidden
      onChange={handleFileInput}
    />

    <Typography>Drop images/videos or click to browse</Typography>

    <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
      <UploadFileIcon fontSize="large" />
    </Box>

    {/* Render media grid */}    
    <MediaGrid
        media={combinedMedia}
      setMedia={(updated) => {
        // only reorder UI media (new uploads)
        setMedia(updated.filter((m) => !m.isExisting));
      }}
      removeMedia={removeMedia}        
      />

  </Box>
  {/* ================= CHECKLIST ================= */}
<Paper sx={{ mt: 2, borderRadius: 2 }}>
  <Button
    fullWidth
    endIcon={
      <ExpandMoreIcon
        sx={{
          transform: checkOpen ? "rotate(180deg)" : "rotate(0deg)",
          transition: "0.2s",
        }}
      />
    }
    onClick={() => setCheckOpen(v => !v)}
    sx={{
      justifyContent: "space-between",
      textTransform: "none",
      fontWeight: 600,
    }}
  >
    Listing checklist
  </Button>

  {checkOpen && (
    <Box sx={{ p: 2, pt: 0 }}>
      <ProductChecklist product={productForChecklist} />
    </Box>
  )}
</Paper>

<Box sx={{ mt: 4 }}>
  {/* ================= ACTION BAR ================= */}
  <Paper
    elevation={1}
    sx={{
      p: 2,
      borderRadius: 2,
      display: "flex",
      flexWrap: "wrap",
      gap: 2,
      alignItems: "center",
      justifyContent: "space-between",
      bgcolor: "#fafafa",
    }}
  >
    {/* LEFT */}
    <Button
      variant="text"
      onClick={() => setTab(2)}
      sx={{ fontWeight: 600 }}
    >
      ← Back
    </Button>

    {/* RIGHT */}
    <Box sx={{ display: "flex", gap: 2 }}>
      <Button
        variant="outlined"
        onClick={saveDraft}
        disabled={saving}
      >
        {saving ? "Saving..." : "Save draft"}
      </Button>

      <Button
        variant="contained"
        onClick={publish}
        sx={{
          bgcolor: "#ffa41c",
          color: "#111",
          fontWeight: 700,
          px: 3,
          "&:hover": { bgcolor: "#f90" },
        }}
      >
        Submit for review
      </Button>
    </Box>
  </Paper>

  


</Box>

</Box>
      )}

{tab === 5 && (
  <Box sx={{ maxWidth: 900 }}>
    <Typography fontWeight={700} sx={{ mb: 2 }}>
      Product Policies
    </Typography>

    {/* RETURN POLICY */}
    <Typography fontWeight={600}>Return Policy</Typography>
    <TextField
      fullWidth
      multiline
      rows={3}
      placeholder="e.g. 7 days return available. Product must be unused."
      value={policies.returnPolicy}
      onChange={(e) =>
        setPolicies({ ...policies, returnPolicy: e.target.value })
      }
      sx={{ mb: 2 }}
    />

    {/* SHIPPING POLICY */}
    <Typography fontWeight={600}>Shipping Policy</Typography>
    <TextField
      fullWidth
      multiline
      rows={3}
      placeholder="e.g. Ships within 2-3 business days."
      value={policies.shippingPolicy}
      onChange={(e) =>
        setPolicies({ ...policies, shippingPolicy: e.target.value })
      }
      sx={{ mb: 2 }}
    />

    {/* WARRANTY */}
    <Typography fontWeight={600}>Warranty</Typography>
    <TextField
      fullWidth
      placeholder="e.g. 1 year manufacturer warranty"
      value={policies.warranty}
      onChange={(e) =>
        setPolicies({ ...policies, warranty: e.target.value })
      }
      sx={{ mb: 2 }}
    />

    {/* PROCESSING TIME */}
    <Typography fontWeight={600}>Processing Time</Typography>
    <Select
      fullWidth
      value={policies.processingTime}
      onChange={(e) =>
        setPolicies({ ...policies, processingTime: e.target.value })
      }
      sx={{ mb: 2 }}
    >
      <MenuItem value="same_day">Same Day</MenuItem>
      <MenuItem value="1_day">1 Day</MenuItem>
      <MenuItem value="2_days">2 Days</MenuItem>
      <MenuItem value="3_5_days">3-5 Days</MenuItem>
      <MenuItem value="1_week">1 Week</MenuItem>
    </Select>

    {/* <Button
      variant="contained"
      sx={{ background: "#ff9900" }}
      onClick={() => setTab(6)}
    >
      Next
    </Button> */}
  </Box>
)}
{tab === 6 && (
  <Box sx={{ maxWidth: 900 }}>
  <Typography variant="h6" fontWeight={700} mb={2}>
    Store Policies
  </Typography>

  {/* RETURN POLICY */}
  <Typography fontWeight={600}>Return Policy</Typography>
  <TextField
    fullWidth
    multiline
    rows={3}
    value={policies.returnPolicy}
    onChange={(e) =>
      setPolicies({ ...policies, returnPolicy: e.target.value })
    }
    placeholder="e.g. 7-day return available"
    sx={{ mb: 2 }}
  />

  {/* SHIPPING POLICY */}
  <Typography fontWeight={600}>Shipping Policy</Typography>
  <TextField
    fullWidth
    multiline
    rows={3}
    value={policies.shippingPolicy}
    onChange={(e) =>
      setPolicies({ ...policies, shippingPolicy: e.target.value })
    }
    placeholder="e.g. Ships within 1-2 days"
    sx={{ mb: 2 }}
  />

  {/* PROCESSING TIME */}
  <Typography fontWeight={600}>Processing Time</Typography>
  <Select
    fullWidth
    value={policies.processingTime}
    onChange={(e) =>
      setPolicies({ ...policies, processingTime: e.target.value })
    }
    sx={{ mb: 2 }}
  >
    <MenuItem value="same_day">Same Day</MenuItem>
    <MenuItem value="1_day">1 Day</MenuItem>
    <MenuItem value="2_days">2 Days</MenuItem>
    <MenuItem value="3_5_days">3-5 Days</MenuItem>
    <MenuItem value="1_week">1 Week</MenuItem>
  </Select>

  <Button variant="contained" onClick={handleSave}>
    Save Policies
  </Button>
</Box>
)}
      {/* TAB 5 — BULK IMPORT */}
      {/* {tab === 5 && (
        <Box sx={{ maxWidth: 700 }}>
          <Typography sx={{ mb: 2 }}>Upload an Excel file with columns: name, category, price, stock, description</Typography>
          <Button variant="outlined" component="label">
            Upload Excel
            <input type="file" hidden accept=".xls,.xlsx" onChange={(e) => {
              const f = e.target.files?.[0];
              if (f) handleBulkUploadProducts(f);
              e.target.value = null;
            }} />
          </Button>

          <Box sx={{ mt: 2 }}>
            <Typography variant="caption" color="text.secondary">Imported products will be stored in localStorage for demo. Integrate your API to persist on server.</Typography>
          </Box>

          <Box sx={{ mt: 3 }}>
            <Button onClick={() => setTab(0)}>Back to Category</Button>
          </Box>
        </Box>
      )} */}
    </Box>
    </Box>
  );
}